export const AppRoute = {
  Condition: 'condition',
  ExpertAnalysis: 'expert-analysis',
  Plans: 'plans',
  OffRoute: 'off-route',
  Reports: 'reports',
  Configuration: 'configuration',
  Devices: 'devices',
  Settings: 'settings',
  Support: 'support',
  About: 'about'
} as const

export const ConditionRoute = {
  Description: 'description',
  MnemonicDiagram: 'mnemonic-diagram',
  KinematicsDiagram: 'kinematic-diagram',
  WorkMode: 'work-mode',
  Results: 'results'
} as const

export const KinematicRoute = {
  Status: 'status',
  Information: 'information',
  Connected: 'connected'
}

export const ResultsGroupRoute = {
  ResultsSummary: 'summary',
  ResultsObjects: 'all-objects'
} as const

export const ResultsMachineRoute = {
  Summary: 'summary',
  Conclusion: 'conclusion'
}

export const ConfigurationRoute = {
  Equipment: 'equipment',
  GroupAdd: 'equipment/add-group',
  MachineAdd: 'equipment/add-machine',
  PointAdd: 'equipment/add-measuring-point',
  MeasurementAdd: 'equipment/add-measurement',
  Threshold: 'threshold',
  WorkMode: 'work-mode',
  MnemonicDiagram: 'mnemonic-diagram',
  KinematicsDiagram: 'kinematics-diagram',
  Connections: 'connections',
  ConnectionsDevice: 'connections/:typeDevice?/:id?'
} as const

export const EquipmentRoute = {
  Group: 'group',
  GroupId: 'group/:groupId',
  Machine: 'machine',
  MachineId: 'machine/:machineId',
  Point: 'measuring-point',
  PointId: 'measuring-point/:pointId',
  Measurement: 'measurement',
  MeasurementId: 'measurement/:measurementId'
} as const

export const SettingsRoute = {
  General: 'general',
  Server: 'server',
  DateBase: 'date-base',
  Users: 'users'
} as const
